var FeaturesModule = /** @class */ (function () {
    function FeaturesModule() {
    }
    return FeaturesModule;
}());
export { FeaturesModule };
